import * as React from 'react'
import { Button } from '@mui/material'
import type { ButtonProps } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'

const DANGER = '#E53935'

const DeleteActionButton: React.FC<ButtonProps> = ({ sx, ...props }) => (
  <Button
    variant="outlined"
    startIcon={<DeleteOutlineRoundedIcon sx={{ fontSize: 18 }} />}
    {...props}
    sx={[
      {
        color: DANGER,
        borderColor: DANGER,
        borderRadius: '4px',
        px: 2,
        height: 36,
        fontFamily: 'Rubik, sans-serif',
        fontSize: '14px',
        fontWeight: 300,
        textTransform: 'none',
        gap: 1,
        '& .MuiButton-startIcon': { m: 0 },
        '&:hover': { borderColor: DANGER, bgcolor: 'rgba(229,57,53,0.06)' },
        '&.Mui-disabled': { color: DANGER, borderColor: DANGER, opacity: 0.4 },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
)

export default DeleteActionButton
